import React from 'react';
import PropTypes from 'prop-types';

import { Button, Container, Segment, Header } from "semantic-ui-react";
import { Link } from 'react-router-dom';

import './styles.css';

const TextList = ({ inverted, copy, withButton }) => {
  const bgColor = inverted ? 'teal' : null;
  const headlineColor = inverted ? 'blue' : null;

  return (
    <Segment basic inverted={inverted} color={bgColor} className='inverted-section'>
      <Container text>
        <Header as='h2' color={headlineColor}>{copy.header}</Header>
        <p>{copy.subheader}</p>
        {copy.listItems.map((item, i) => {
          return (
            [<Header as='h3' color={headlineColor} key={`${i}_headline`}>
              {item.headline}
            </Header>,
            <p key={`${i}_paragraph`}>{item.paragraph}</p>]
          );
        })}
        {withButton ?
        <div className="buttonWrapper">

        <Link to={copy.buttonUrl}>
          <Button secondary size="huge">{copy.buttonCopy}</Button>
        </Link>
        </div>
        :
        null
        }
      </Container>
    </Segment>
  );
};

export default TextList;

TextList.propTypes = {
  inverted: PropTypes.bool.isRequired,
  copy: PropTypes.shape({
    header: PropTypes.string.isRequired,
    subheader: PropTypes.string,
    listItems: PropTypes.arrayOf(
      PropTypes.shape({
        headline: PropTypes.string.isRequired,
        paragraph: PropTypes.string.isRequired
      })

    )
  })
}


// WEBPACK FOOTER //
// ./src/Product/TextList.js